import React from 'react'

const Contact = () => {
    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>Contact</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>
            <div className="inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 ">
                            <ul className="list-group list-group-flush list-group-bordered">
                                <li className="list-group-item">
                                    <div className="list-group-item-figure">
                                        <div className="tile ">
                                            <span className="fa fa-map-marker"></span>
                                        </div>
                                    </div>
                                    <div className="list-group-item-body">
                                        <strong>Adresse</strong><br/>
                                        <a href="https://www.google.fr/maps/search/384+Avenue+Djouari+Plateau+des+15+ans,+Moungali,+Brazzaville/@-4.2627933,15.2597643,17z/data=!3m1!4b1">384 Avenue Djouari Plateau des 15 ans, Moungali, Brazzaville</a>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="list-group-item-figure">
                                        <div className="tile ">
                                            <span className="fa fa-envelope"></span>
                                        </div>
                                    </div>
                                    <div className="list-group-item-body">
                                        <strong>Email</strong><br/>
                                        <a href="mailto:contact@association-iaicongo.org">contact@association-iaicongo.org</a>
                                    </div>
                                </li>
                                <li className="list-group-item">
                                    <div className="list-group-item-figure">
                                        <div className="tile bg-primaryx">
                                            <span className="fa fa-phone"></span>
                                        </div>
                                    </div>
                                    <div className="list-group-item-body">
                                        <strong>Téléphone</strong><br/>
                                        <a href="tel:+242068389195">+242 06 838 91 95</a>
                                    </div>
                                </li>
                                <li className="list-group-item align-center hidden">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2264.775922690368!2d11.863429862993842!3d-4.807421410905642!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1a60a517c6d7ded1%3A0xeef42f416b812557!2sPharmacie%204%20Chemins!5e1!3m2!1sfr!2sfr!4v1663791239950!5m2!1sfr!2sfr"
                                        width="600" height="435" style={{border:0, margin:'auto'}} allowFullScreen=""
                                        loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-7 hidden">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Email</label>
                                    <input type="email" className="form-control" id="exampleInputEmail1"
                                           aria-describedby="emailHelp" placeholder="Enter email"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Sujet</label>
                                    <input type="text" className="form-control" id="exampleInputEmail1"
                                           aria-describedby="emailHelp" placeholder="Enter sujet"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleInputEmail1">Votre Message</label>
                                    <textarea name="description" rows="5" className="form-control" id="exampleInputEmail1"></textarea>
                                </div>
                                <button type="submit" className="btn btn-primary">Envoyer</button>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Contact;